let moment = require("moment/moment");


// ##############################
// Wallet Balance
// #############################


const defaultWalletData = {

    // labels: ["01 Nov", "02 Nov", "03 Nov", "04 Nov", "05 Nov", "06 Nov", "07 Nov", "08 Nov", "09 Nov", "10 Nov", "11 Nov", "12 Nov"],
    datasets: [
        {
            label: "Credit",
            fillColor: "rgba(76,175,80,0.8)",
            strokeColor: "rgba(76,175,80,1)",
            pointColor: "rgba(76,175,80,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#4caf50",
            pointHighlightStroke: "rgba(76,175,80,0.9)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        // {
        //     label: "Debit",
        //     fillColor: "rgba(235,42,35,0.2)",
        //     strokeColor: "rgba(235,42,35,1)",
        //     pointColor: "rgba(235,42,35,1)",
        //     pointStrokeColor: "#fff",
        //     pointHighlightFill: "#eb2a37",
        //     pointHighlightStroke: "rgba(235,42,35,1)",
        //     data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        // },
    ]
};
const setWalletData = (data, startDate, endDate) => {

    startDate = moment(startDate).format("YYYY-MM-DD");
    endDate = moment(endDate).format("YYYY-MM-DD");
    let duration = moment.duration(moment(endDate).diff(moment(startDate))).asDays();

    let labels = [];

    for (let i = 0; i <= duration; i++) {
        let m = moment(startDate).add(i, 'day').format('YYYY-MM-DD');
        labels.push(m);
    }

    let datasets = [];
    let chartRecords = data;
    let chartRecordsLength = chartRecords.length;
    let allAirlinesData = [];

    for (let item of chartRecords) {
        //add to dataset

        let airlineData = new Array(duration).fill(null);
        for (let d of item.CurrentTokenMovement) {
            const date__ = moment(d.MovementDate).format("YYYY-MM-DD");
            const indexFound = labels.findIndex(item => item === date__);
            airlineData[indexFound] = d.CurrentToken;
        }
        allAirlinesData.push(airlineData);
    }

    let chartColor = [
        {
            fillColor: "rgba(76,175,80,0.8)",
            strokeColor: "rgba(76,175,80,1)",
            pointColor: "rgba(76,175,80,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#4caf50",
            pointHighlightStroke: "rgba(76,175,80,0.9)",
        },
        {
            fillColor: "rgba(235,42,35,0.2)",
            strokeColor: "rgba(235,42,35,1)",
            pointColor: "rgba(235,42,35,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#eb2a37",
            pointHighlightStroke: "rgba(235,42,35,1)",
        },
        {
            fillColor: "rgba(63,191,63,0.8)",
            strokeColor: "rgba(63,191,63,1)",
            pointColor: "rgba(63,191,63,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#3FBF3F",
            pointHighlightStroke: "rgba(63,191,63,0.9)",
        },
        {
            fillColor: "rgba(191,63,191,0.8)",
            strokeColor: "rgba(191,63,191,1)",
            pointColor: "rgba(191,63,191,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#BF3FBF",
            pointHighlightStroke: "rgba(191,63,191,0.9)",
        },
        {
            fillColor: "rgba(63,191,191,0.8)",
            strokeColor: "rgba(63,191,191,1)",
            pointColor: "rgba(63,191,191,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#3FBFBF",
            pointHighlightStroke: "rgba(63,191,191,0.9)",
        },
        {
            fillColor: "rgba(191,127,63,0.8)",
            strokeColor: "rgba(191,127,63,1)",
            pointColor: "rgba(191,127,63,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#BF7F3F",
            pointHighlightStroke: "rgba(191,127,63,0.9)",
        },
        {
            fillColor: "rgba(63,140,191,0.8)",
            strokeColor: "rgba(63,140,191,1)",
            pointColor: "rgba(63,140,191,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#3F8CBF",
            pointHighlightStroke: "rgba(63,140,191,0.9)",
        },
        {
            fillColor: "rgba(146,128,11,0.8)",
            strokeColor: "rgba(146,128,11,1)",
            pointColor: "rgba(146,128,11,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#92800B",
            pointHighlightStroke: "rgba(146,128,11,0.9)",
        }
    ]


    for (let i = 0; i < chartRecordsLength; i++) {
        //add to dataset
        datasets.push(
            {
                label: chartRecords[i].Airline,
                ...chartColor[i],
                data: allAirlinesData[i]
            },
        );
    }


    let walletChartData = {
        labels: labels,
        datasets: datasets
    };

    return {
        walletChartData
    }
};

module.exports = {
    defaultWalletData,
    setWalletData
};



// WEBPACK FOOTER //
// ./src/Regional-Views/Settlement/chartvariables.js